export default "__VITE_ASSET__CL6jpmjU__"